export const POLL_INTERVAL_MS = 45_000;

export const CAMPAIGN_STATUS = {
  RUNNING: 'running',
  VERIFYING: 'verifying',
  VERIFY_PENDING: 'verify_pending',
  READY: 'ready',
};

export const TEST_DEVICE_HINT =
  'Получает прошивки из тестового канала. Обновления — только после запуска обкатки.';

export const START_CONFIRM_TEXT = 'Обновление уйдёт тестовым устройствам без подтверждения владельца.';

export const STATUS_META = {
  [CAMPAIGN_STATUS.RUNNING]: {
    title: 'Этап 1 — переход на тестовую-1',
  },
  [CAMPAIGN_STATUS.VERIFYING]: {
    title: 'Этап 2 — переход на тестовую-2',
  },
  [CAMPAIGN_STATUS.VERIFY_PENDING]: {
    title: 'Этап 1 завершён, ожидается тестовая-2',
  },
  [CAMPAIGN_STATUS.READY]: {
    title: 'Оба этапа завершены',
  },
};
